import { Component, Input, ViewEncapsulation } from "@angular/core";
import * as _ from "lodash-es";
import { SubSink } from "subsink";
import { RosterCodeSettingService } from "../services/roster-code-setting.service";
import { IRosterCode } from "../shared/models/roster-code";
import { IRosterCodeSetting } from "../shared/models/roster-code-setting";
import { ToastService } from "../shared/toast/toast.service";

@Component({
  selector: "pps-manage-roster-code-settings",
  templateUrl: "./manage-roster-code-settings.component.html",
  styles:[`
    .roster-code-setting{
    }

    .roster-code-setting .roster-code-setting-preview{
      border: 1px solid #cccccc;
    }

    .roster-code-setting .p-colorpicker-preview{
      min-width: 50px;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class ManageRosterCodeSettingsComponent{
  private subs = new SubSink();

  @Input() rosterCodeSettings: IRosterCodeSetting[] = [];

  presetColors = [
    "#5B9BD5", "#CCCCFF", "FF9900", "#0066FF", "#9933FF",
    "#FF0066", "#00FFFF", "#617099", "#28F0A0", "#FEC2F1", 
    "#DC4264", "#FF66FF", "#FFFF00", "#92D050"
  ];
  changeTracking: {
    [id: string]:{
      rosterCodeId: number,
      rosterCodeSettingId: number,
      index: number,
      subIndex: number,
      oldValue: {
        foregroundColor: string,
        backgroundColor: string
      },
      newValue: {
        foregroundColor: string,
        backgroundColor: string
      }
    }
  } = {};

  rosterCodes: [{
    rosterCodeSettingId: number,
    rosterCode: IRosterCode,
    description: string,
    foregroundColor: string,
    backgroundColor: string
  }[]] = [[]];

  constructor(
    private _rosterCodeSettingService: RosterCodeSettingService,
    private _toast: ToastService
  ){
  }

  ngOnInit(): void {
    this.loadData();
  }  

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  loadData(){
    this.rosterCodes = [[]];
    this.changeTracking = {};
    let rcsObject = {};
          
    this.rosterCodeSettings.forEach( rcs => {
      let rcsItem = {
        rosterCodeSettingId: rcs.id,
        rosterCode: rcs.rosterCode,
        description: rcs.ticketStatus.description,
        foregroundColor: rcs.foregroundColor,
        backgroundColor: rcs.backgroundColor
      };
      
      if (rcsObject.hasOwnProperty(rcs.rosterCode.code)){
        rcsObject[rcs.rosterCode.code].push(rcsItem);
      }else{
        rcsObject[rcs.rosterCode.code] = [rcsItem];
      }
    });
        
    Object
      .keys(rcsObject)
      .sort()
      .forEach(code => this.rosterCodes.push(rcsObject[code]));

    this.rosterCodes.forEach((rc, index) => {
      rc.forEach((rcs, subIndex) => {
        this.changeTracking[rcs.rosterCode.id + "_" + rcs.rosterCodeSettingId] = {
          rosterCodeId: rcs.rosterCode.id,
          rosterCodeSettingId: rcs.rosterCodeSettingId,
          index: index,
          subIndex: subIndex,
          oldValue: {
            foregroundColor: rcs.foregroundColor,
            backgroundColor: rcs.backgroundColor
          },
          newValue:{
            foregroundColor: null,
            backgroundColor: null
          }
        };
      });
    });
  }

  changeForeColor(rcs){
    this.changeTracking[`${rcs.rosterCode.id}_${rcs.rosterCodeSettingId}`]["newValue"]["foregroundColor"] = rcs.foregroundColor;
  }

  changeBackColor(rcs){
    this.changeTracking[`${rcs.rosterCode.id}_${rcs.rosterCodeSettingId}`]["newValue"]["backgroundColor"] = rcs.backgroundColor;
  }

  saveChanges(){
    let changedSettings: IRosterCodeSetting[] = this.getChangedSettings();
        
    if (changedSettings.length > 0){
      this.subs.sink = this._rosterCodeSettingService.update(changedSettings)
        .subscribe(res => {
          if (res.succeed){
            this._toast.succeeded("Changes has been saved");
            this.loadData();            
          } else{
            this._toast.failed("Saving changes failed");
          }
        });
    }
  }

  private getChangedSettings():IRosterCodeSetting[]{
    let changedSettings: IRosterCodeSetting[] = [];
    for(var rcsId in this.changeTracking){
      let ctObj = this.changeTracking[rcsId];
      
      if (ctObj.newValue.foregroundColor || ctObj.newValue.backgroundColor){
        changedSettings.push({
          id: ctObj.rosterCodeSettingId,
          rosterCode: {
            id: ctObj.rosterCodeId
          },
          foregroundColor: ctObj.newValue.foregroundColor,
          backgroundColor: ctObj.newValue.backgroundColor
        });
      }
    }
    
    return changedSettings;
  }

  discardChanges(){
    let changedSettings: IRosterCodeSetting[] = this.getChangedSettings();

    for(var rcsId in this.changeTracking){
      let ctObj = this.changeTracking[rcsId];
      this.rosterCodes[ctObj.index][ctObj.subIndex].foregroundColor = ctObj.oldValue.foregroundColor;
      this.rosterCodes[ctObj.index][ctObj.subIndex].backgroundColor = ctObj.oldValue.backgroundColor;
    }

    this.resetChangeTracking(changedSettings);
  }

  private resetChangeTracking(changedSettings:IRosterCodeSetting[]){
    changedSettings.forEach(cs => {
      let ctObj = this.changeTracking[`${cs.rosterCode.id}_${cs.id}`];
      if (ctObj){
        ctObj.oldValue.foregroundColor = cs.foregroundColor || ctObj.oldValue.foregroundColor;
        ctObj.oldValue.backgroundColor = cs.backgroundColor || ctObj.oldValue.backgroundColor;

        ctObj.newValue.foregroundColor = ctObj.newValue.backgroundColor = null; 
      }
    });
  }

  shouldEnableSave(){
    let changedSettings: IRosterCodeSetting[] = this.getChangedSettings();
    return changedSettings.length > 0;
  }
}